import { Component, Input } from '@angular/core';

// Wraps a projected form control with the app-standard copy-to-clipboard icon.
// Usage:
//   <eos-copyable-input [value]="form.get('field').value">
//     <input ... />
//     <div class="invalid-feedback">...</div>
//   </eos-copyable-input>
@Component({
  selector: 'eos-copyable-input',
  template: `
    <div class="inner-addon right-addon">
      <a *ngIf="value" class="rmv-btn glyphicon">
        <img title="Copy" [eosClipboarder]="value" class="ml-1 me-2 dark dark-custom" src="design/images/copy.png">
        <img title="Copy" [eosClipboarder]="value" class="ml-1 me-2" src="design/images/copy-light.png">
      </a>
      <ng-content></ng-content>
    </div>
  `,
  styles: [':host { display: block; }']
})
export class CopyableInputComponent {
  @Input() value: string | number | null | undefined;
}
